module.exports = __webpack_public_path__ + "img/more_vert.f88fbc2f.svg";